export default "__VITE_ASSET__BKlYPhJo__"